import React from 'react';

const PatternLeft = ({ viewBox, fill }) => (
	<svg
		width="153.86"
		height="123"
		viewBox={viewBox}
		className="finance__pattern-left">
		<g>
			<path
				d="M110.52,93a1.82,1.82,0,0,1-.31.44h0a40,40,0,0,1-24,11.86,39.42,39.42,0,0,1-25.69-5.79A1.91,1.91,0,0,1,60,96.84l6-8.76a1.89,1.89,0,0,1,2.55-.55,25.27,25.27,0,0,0,15.12,3.53,25.64,25.64,0,0,0,14.49-6l.18-.14c.24-.21,1.12-.91,1.7-.86a1.72,1.72,0,0,1,.88.32l9,6.27A1.9,1.9,0,0,1,110.52,93Z"
				fill={fill}
			/>
			<path
				d="M84,25.18a1.85,1.85,0,0,1-.34-.41h0a40.2,40.2,0,0,1-5-26.08,40.39,40.39,0,0,1,12-23.39,1.84,1.84,0,0,1,2.7.14l6.69,8A1.92,1.92,0,0,1,99.94-14,25.93,25.93,0,0,0,92.75-.24a25.83,25.83,0,0,0,1.93,15.45,1.89,1.89,0,0,1,.09.21,3.13,3.13,0,0,1,.37,1.85,1.91,1.91,0,0,1-.52.78l-8.19,7.11A1.8,1.8,0,0,1,84,25.18Z"
				fill={fill}
			/>
			<path
				d="M40.83-25.51a1.59,1.59,0,0,1,0,.53h0A38.73,38.73,0,0,1,28.93-1.48a39.83,39.83,0,0,1-24,10.72,1.92,1.92,0,0,1-2.09-1.8L2.31-3A1.88,1.88,0,0,1,4-4.93a25.53,25.53,0,0,0,14.22-6.21,25,25,0,0,0,7.9-13.27,1.42,1.42,0,0,1,.05-.22c.07-.31.34-1.37.83-1.68a1.83,1.83,0,0,1,.9-.27l11-.42A1.9,1.9,0,0,1,40.83-25.51Z"
				fill={fill}
			/>
			<path
				d="M121.22,26.05a1.65,1.65,0,0,1,0,.54h0a38.71,38.71,0,0,1-11.91,23.49,39.88,39.88,0,0,1-24,10.72A1.92,1.92,0,0,1,83.22,59l-.51-10.42a1.87,1.87,0,0,1,1.69-1.94,25.6,25.6,0,0,0,14.22-6.21,24.94,24.94,0,0,0,7.9-13.28c0-.07,0-.14,0-.22.07-.3.34-1.36.83-1.67a1.77,1.77,0,0,1,.91-.28l11-.42A1.9,1.9,0,0,1,121.22,26.05Z"
				fill={fill}
			/>
			<path
				d="M78.47,116.06a1.59,1.59,0,0,1,0,.53h0a38.77,38.77,0,0,1-11.91,23.5,39.93,39.93,0,0,1-24,10.71A1.91,1.91,0,0,1,40.47,149L40,138.58a1.87,1.87,0,0,1,1.69-1.94,25.53,25.53,0,0,0,14.22-6.21,25,25,0,0,0,7.9-13.27c0-.08,0-.15,0-.23.07-.3.34-1.36.83-1.67a1.74,1.74,0,0,1,.91-.28l11-.42A1.9,1.9,0,0,1,78.47,116.06Z"
				fill={fill}
			/>
			<path
				d="M50.38,2.43a1.78,1.78,0,0,1,.53.11h0a39.79,39.79,0,0,1,20.53,16.7,39.19,39.19,0,0,1,5.47,25.45,1.88,1.88,0,0,1-2.2,1.6L64.39,44.44a1.88,1.88,0,0,1-1.55-2.06,25.13,25.13,0,0,0-3.11-15A25.56,25.56,0,0,0,48.38,16.79l-.21-.1c-.29-.14-1.27-.64-1.47-1.18a1.72,1.72,0,0,1-.08-.93L48.5,4A1.88,1.88,0,0,1,50.38,2.43Z"
				fill={fill}
			/>
			<path
				d="M153.6,3.62a1.66,1.66,0,0,1-.36.42h0a39.59,39.59,0,0,1-24.74,9.75,39.05,39.05,0,0,1-24.94-7.9,1.92,1.92,0,0,1-.31-2.74L110-5a1.88,1.88,0,0,1,2.57-.33A25,25,0,0,0,127.21-.59a25.4,25.4,0,0,0,14.84-4.74l.19-.13A3.26,3.26,0,0,1,144-6.17a1.71,1.71,0,0,1,.85.4l8.33,7A1.9,1.9,0,0,1,153.6,3.62Z"
				fill={fill}
			/>
			<path
				d="M-4.72,23.31A1.33,1.33,0,0,1-4.36,23h0a36.75,36.75,0,0,1,25-5.8,45.23,45.23,0,0,1,24.8,11.25,1.86,1.86,0,0,1,.25,2.69L38.77,38A1.91,1.91,0,0,1,36.2,38a29.11,29.11,0,0,0-14.59-6.74,24.12,24.12,0,0,0-14.95,2.4l-.2.1a3,3,0,0,1-1.77.43,2.24,2.24,0,0,1-.84-.51l-8.2-7.93A1.87,1.87,0,0,1-4.72,23.31Z"
				fill={fill}
			/>
			<path
				d="M34.61,53.73a1.61,1.61,0,0,1,.49-.21h0a41.11,41.11,0,0,1,26.62,2,40.42,40.42,0,0,1,19.5,17.53,1.81,1.81,0,0,1-.86,2.53l-9.52,4.27a2,2,0,0,1-2.48-.8A25.86,25.86,0,0,0,57,68.66a26.59,26.59,0,0,0-15.51-2.2l-.22,0a3.43,3.43,0,0,1-1.9-.13,1.77,1.77,0,0,1-.61-.71L34,56A1.77,1.77,0,0,1,34.61,53.73Z"
				fill={fill}
			/>
			<path
				d="M148.83,92.55a1.68,1.68,0,0,1-.52.14h0A38.51,38.51,0,0,1,123,86.59,38.92,38.92,0,0,1,107.25,66a1.9,1.9,0,0,1,1.27-2.41l10-2.85A1.85,1.85,0,0,1,120.73,62a24.9,24.9,0,0,0,23.76,16.77h.22a3.17,3.17,0,0,1,1.81.42,1.79,1.79,0,0,1,.47.8l2.84,10.4A1.86,1.86,0,0,1,148.83,92.55Z"
				fill={fill}
			/>
			<path
				d="M10.85,92.08a1.85,1.85,0,0,1-.08.54h0a40.91,40.91,0,0,1-16,21.62A39,39,0,0,1-30.47,121a1.87,1.87,0,0,1-1.68-2.16l1.48-10.57a1.91,1.91,0,0,1,2-1.66,25.07,25.07,0,0,0,14.93-3.86,26.16,26.16,0,0,0,10.15-12l.09-.22c.13-.29.59-1.31,1.13-1.54a1.78,1.78,0,0,1,.92-.13L9.24,90.25A1.85,1.85,0,0,1,10.85,92.08Z"
				fill={fill}
			/>
			<path
				d="M2,158.27a1.75,1.75,0,0,1-.23-.48h0a41,41,0,0,1,1-26.53A40.3,40.3,0,0,1,19.3,111.11a1.77,1.77,0,0,1,2.53.73l4.62,9.27a2,2,0,0,1-.7,2.5,25.87,25.87,0,0,0-9.87,11.8,26.35,26.35,0,0,0-1.55,15.49c0,.08,0,.15,0,.23a3.37,3.37,0,0,1,0,1.88,1.68,1.68,0,0,1-.68.64l-9.36,5.13A1.77,1.77,0,0,1,2,158.27Z"
				fill={fill}
			/>
			<path
				d="M52.66,118.84a1.87,1.87,0,0,1-.54,0h0a40.48,40.48,0,0,1-22.57-14.73,40,40,0,0,1-8.29-25.22A1.91,1.91,0,0,1,23.3,77L34,77.74a1.92,1.92,0,0,1,1.79,1.92,25.58,25.58,0,0,0,4.77,14.92,26,26,0,0,0,12.63,9.48l.22.08c.3.11,1.35.51,1.61,1a1.75,1.75,0,0,1,.18.94l-.76,11A1.88,1.88,0,0,1,52.66,118.84Z"
				fill={fill}
			/>
			<path
				d="M-12.5,76a1.61,1.61,0,0,1,0-.54h0A40.88,40.88,0,0,1,1.05,52.3a39.07,39.07,0,0,1,24.3-9.43,1.86,1.86,0,0,1,1.89,1.94l-.34,10.6a1.93,1.93,0,0,1-1.81,1.87,25,25,0,0,0-14.38,5.45,26.21,26.21,0,0,0-8.78,13,1.42,1.42,0,0,1-.07.22c-.09.31-.44,1.37-.95,1.65a1.61,1.61,0,0,1-.9.23l-10.73-.23A1.81,1.81,0,0,1-12.5,76Z"
				fill={fill}
			/>
		</g>
	</svg>
);

export default PatternLeft;
